import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { CSSProperties, useMemo, useState } from "react";
import { timeZonesOptions } from "../../../constants/timezones";
import { Box, SxProps, Typography } from "@mui/material";
import EditIcon from "../../../assets/images/expert/edit.png";
import CustomButton from "../../../atoms/Button";
import CustomBtnFilled from "../../../atoms/form-molecules/CustomBtnFilled";
import { TTimeZoneInput } from "./helper";
import { getLabelFromTimezone, getTimezoneFromLabel, getTimezoneLabels } from "../../../pages/project-calendar/helper";


export default function TimeZoneInput({ timeZone, handleSetTimeZone, BoxStyle, UpdateBtnStyle, inputStyle }: TTimeZoneInput) {

  const [timeZoneLocal, setTimeZoneLocal] = useState<string>(
    timeZone
  );
  const timeZonesOptions = useMemo(() => {
    return getTimezoneLabels()
  }, [])

  return (
    <Box sx={BoxStyle}>
      <Typography sx={{ fontWeight: "medium", mb: "4px", fontSize: "12px" }}>
        Timezone:
      </Typography>
      <Autocomplete
        sx={{ backgroundColor: "white", minWidth: "200px", ...inputStyle }}
        size="small"
        fullWidth
        onChange={(e, data) => {
          setTimeZoneLocal(getTimezoneFromLabel(data))
        }}
        value={getLabelFromTimezone(timeZoneLocal)}
        options={timeZonesOptions}
        disableClearable
        renderInput={(params: any) => (
          <TextField {...params} placeholder={"Select Your TimeZone"} />
        )}
      />

      {timeZone && timeZoneLocal != timeZone ? (
        <CustomBtnFilled
          styles={{ marginTop: "24px", ...UpdateBtnStyle }}
          label={"Update"}
          variant="contained"
          onClick={() => handleSetTimeZone(timeZoneLocal)}
        />
      ) : null}
    </Box>
  );
}
